/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../notification/message/message.component.ngfactory';
import * as import2 from '../../notification/message/message.component';
import * as import3 from '../../notification/notification.service';
import * as import4 from 'ng2-translate/src/translate.pipe';
import * as import5 from 'ng2-translate/src/translate.service';
import * as import6 from '@angular/common';
import * as import7 from '../../ui-elements/touchable.directive';
import * as import8 from '../../ui-elements/toggle/toggle.component.ngfactory';
import * as import9 from '../../ui-elements/toggle/toggle.component';
import * as import10 from '../../buttons/icon-button/icon-button.component.ngfactory';
import * as import11 from '../../buttons/icon-button/icon-button.component';
import * as import12 from '../../inputs/form/form.component.ngfactory';
import * as import13 from '../../inputs/form/form.component';
import * as import14 from '../../inputs/text-field/text-field.component.ngfactory';
import * as import15 from '@angular/forms';
import * as import16 from '../../inputs/text-field/text-field.component';
import * as import17 from '../../inputs/selector-control/selector-control.component.ngfactory';
import * as import18 from '../../inputs/selector-control/selector-control.component';
import * as import19 from '../../buttons/button/button.component.ngfactory';
import * as import20 from '../../buttons/button/button.component';
import * as import21 from '../../orchestration/session.model';
import * as import22 from '../../orchestration/responsive.service';
import * as import23 from '../../page-layout/page-footer-control.directive';
import * as import24 from '../../buttons/link/link.component.ngfactory';
import * as import25 from '../../buttons/link/link.component';
import * as import26 from '../../string-utils/possessive.pipe';
import * as import27 from '../../html-utils/html.pipe';
import * as import28 from '@angular/platform-browser';
import * as import29 from '../../string-utils/currency.pipe';
import * as import30 from '../../page-layout/modal-page-layout/modal-page-layout.component.ngfactory';
import * as import31 from '../../page-layout/modal-page-layout/modal-page-layout.component';
import * as import32 from '../../orchestration/page';
import * as import33 from '../../orchestration/navigation.service';
import * as import34 from './group-order-page.component';
import * as import35 from '../../orchestration/navigation-params';
import * as import36 from '../../ui-elements/loading/loading.service';
import * as import37 from '../../identity/identity.model';
import * as import38 from '../../order/order.model';
import * as import39 from '../group-order.model';
const styles_GroupOrderPageComponent:any[] = ([] as any[]);
export const RenderType_GroupOrderPageComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_GroupOrderPageComponent,
  data: {}
}
);
function View_GroupOrderPageComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-content-message',[[
        'class',
        'group-order-error'
      ]
    ],[
      [
        2,
        'closable',
        (null as any)
      ]
      ,
      [
        2,
        'actionable',
        (null as any)
      ]
      ,
      [
        2,
        'errorLevel',
        (null as any)
      ]
      ,
      [
        2,
        'warningLevel',
        (null as any)
      ]
      ,
      [
        2,
        'successLevel',
        (null as any)
      ]
      ,
      [
        2,
        'infoLevel',
        (null as any)
      ]
      ,
      [
        2,
        'horizontal',
        (null as any)
      ]
      ,
      [
        2,
        'vertical',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import1.View_ContentMessageComponent_0,import1.RenderType_ContentMessageComponent)),
      import0.ɵdid(5488640,[[
        3,
        4
      ]
    ],1,import2.ContentMessageComponent,[
      import0.ElementRef,
      import3.NotificationService
    ]
    ,{
      level: [
        0,
        'level'
      ]
      ,
      text: [
        1,
        'text'
      ]
      ,
      translationParams: [
        2,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,5,{links: 1})
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_8:any = co.MessageLevel.ERROR;
    const currVal_9:any = co.error;
    const currVal_10:any = co.errorParams;
    ck(v,1,0,currVal_8,currVal_9,currVal_10);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).closable;
    const currVal_1:any = import0.ɵnov(v,1).actionable;
    const currVal_2:any = import0.ɵnov(v,1).isErrorLevel;
    const currVal_3:any = import0.ɵnov(v,1).isWarningLevel;
    const currVal_4:any = import0.ɵnov(v,1).isSuccessLevel;
    const currVal_5:any = import0.ɵnov(v,1).isInfoLevel;
    const currVal_6:any = import0.ɵnov(v,1).isHorizontalLayout;
    const currVal_7:any = import0.ɵnov(v,1).isVerticalLayout;
    ck(v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7);
  });
}
function View_GroupOrderPageComponent_4(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'group-order-intro-heading'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,2,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),1),import0.ɵunv(v,0,0,import0.ɵnov(v,1).transform('woa.message.group-order.intro.create.heading'))));
    ck(v,0,0,currVal_0);
  });
}
function View_GroupOrderPageComponent_3(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),10,'div',[[
        'class',
        'group-order-intro'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import6.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['no-details']),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_4)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'group-order-intro-body'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'group-order-intro';
    const currVal_1:any = ck(v,2,0,!co.groupOrderModel.canStartGroupOrder);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_2:any = co.showEditIntroHeading;
    ck(v,5,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_3:any = import0.ɵunv(v,7,0,ck(v,9,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,7,0,import0.ɵnov(v,8).transform(co.editIntroBody))));
    ck(v,7,0,currVal_3);
  });
}
function View_GroupOrderPageComponent_5(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'div',[[
        'class',
        'participation-intro'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'participation-intro-heading'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    import0.ɵppd(1),
    import0.ɵpod([
      'otherGroupOrderName',
      'existingGroupOrderName'
    ]
    ),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',[[
        'class',
        'participation-intro-body'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵppd(1),
    import0.ɵppd(1),
    import0.ɵpod([
      'otherGroupOrderName',
      'otherGroupOrderOwnerName',
      'existingGroupOrderName'
    ]
    ),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,2,0,ck(v,7,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,2,0,import0.ɵnov(v,6).transform(co.participantIntroHeading,ck(v,5,0,import0.ɵunv(v,2,0,ck(v,3,0,import0.ɵnov((<any>(<any>v.parent).parent),0),((co.newestOtherTransferTarget == null)? (null as any): co.newestOtherTransferTarget.name))),import0.ɵunv(v,2,0,ck(v,4,0,import0.ɵnov((<any>(<any>v.parent).parent),0),((co.existingTransferTarget == null)? (null as any): co.existingTransferTarget.name))))))));
    ck(v,2,0,currVal_0);
    const currVal_1:any = import0.ɵunv(v,9,0,ck(v,14,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,9,0,import0.ɵnov(v,13).transform(co.participantIntroBody,ck(v,12,0,import0.ɵunv(v,9,0,ck(v,10,0,import0.ɵnov((<any>(<any>v.parent).parent),0),((co.newestOtherTransferTarget == null)? (null as any): co.newestOtherTransferTarget.name))),((co.newestOtherTransferTarget == null)? (null as any): co.newestOtherTransferTarget.name),import0.ɵunv(v,9,0,ck(v,11,0,import0.ɵnov((<any>(<any>v.parent).parent),0),((co.existingTransferTarget == null)? (null as any): co.existingTransferTarget.name))))))));
    ck(v,9,0,currVal_1);
  });
}
function View_GroupOrderPageComponent_2(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),7,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_3)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_5)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = (co.mode === co.GroupOrderPageMode.EDIT);
    ck(v,3,0,currVal_0);
    const currVal_1:any = (co.mode === co.GroupOrderPageMode.PARTICIPANTS);
    ck(v,6,0,currVal_1);
  },(null as any));
}
function View_GroupOrderPageComponent_7(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),32,'div',[[
        'class',
        'group-order-details-instructions'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleEditInstructions(import0.ɵnov(v,13))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'group-order-details-instructions-heading'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(4210688,(null as any),0,import7.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'group-order-details-instructions-heading-label'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-toggle',[[
        'class',
        'group-order-details-instructions-heading-toggle'
      ]
    ],(null as any),(null as any),(null as any),import8.View_ToggleComponent_0,import8.RenderType_ToggleComponent)),
      import0.ɵdid(573440,(null as any),0,import9.ToggleComponent,[import0.ChangeDetectorRef],{active: [
        0,
        'active'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,[[
        'instructions',
        1
      ]
      ],(null as any),18,'ol',[[
        'class',
        'group-order-details-instructions-body'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import6.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['expanded']),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'li',[[
        'class',
        'group-order-details-instructions-body-item'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'li',[[
        'class',
        'group-order-details-instructions-body-item'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'li',[[
        'class',
        'group-order-details-instructions-body-item'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.instructionsExpanded;
    ck(v,10,0,currVal_1);
    const currVal_2:any = 'group-order-details-instructions-body';
    const currVal_3:any = ck(v,15,0,co.instructionsExpanded);
    ck(v,14,0,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,5,0,ck(v,7,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,5,0,import0.ɵnov(v,6).transform('woa.message.group-order.instructions.heading'))));
    ck(v,5,0,currVal_0);
    const currVal_4:any = import0.ɵunv(v,17,0,ck(v,19,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,17,0,import0.ɵnov(v,18).transform('woa.message.group-order.instructions.body.point1'))));
    ck(v,17,0,currVal_4);
    const currVal_5:any = import0.ɵunv(v,22,0,ck(v,24,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,22,0,import0.ɵnov(v,23).transform('woa.message.group-order.instructions.body.point2'))));
    ck(v,22,0,currVal_5);
    const currVal_6:any = import0.ɵunv(v,27,0,ck(v,29,0,import0.ɵnov((<any>(<any>v.parent).parent),1),import0.ɵunv(v,27,0,import0.ɵnov(v,28).transform('woa.message.group-order.instructions.body.point3'))));
    ck(v,27,0,currVal_6);
  });
}
function View_GroupOrderPageComponent_9(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'group-order-details-participants-message'
      ]
      ],[[
        8,
        'innerHTML',
        1
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,0,0,ck(v,2,0,import0.ɵnov((<any>(<any>(<any>v.parent).parent).parent),1),import0.ɵunv(v,0,0,import0.ɵnov(v,1).transform('woa.message.group-order.noParticipants'))));
    ck(v,0,0,currVal_0);
  });
}
function View_GroupOrderPageComponent_13(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'group-order-details-participants-requests-request-subtotal'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    import0.ɵppd(1)
  ]
  ,(null as any),(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,1,0,ck(v,2,0,import0.ɵnov((<any>(<any>(<any>(<any>(<any>(<any>v.parent).parent).parent).parent).parent).parent),2),(<any>(<any>v.parent).parent).context.$implicit.subTotal));
    ck(v,1,0,currVal_0);
  });
}
function View_GroupOrderPageComponent_12(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),12,'div',[[
        'class',
        'group-order-details-participants-requests-request'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import6.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['removed']),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'group-order-details-participants-requests-request-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                            ',
      '\n                        '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_13)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-icon-button',[[
        'class',
        'group-order-details-participants-requests-request-remove'
      ]
    ],[
      [
        1,
        'type',
        0
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'unavailable',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.toggleRequest((<any>v.parent).context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import10.View_IconButtonComponent_0,import10.RenderType_IconButtonComponent)),
      import0.ɵdid(49152,(null as any),0,import11.IconButtonComponent,([] as any[]),{type: [
        0,
        'type'
      ]
    },{onActivate: 'onActivate'}),
    (l()(),import0.ɵted((null as any),['\n                    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = 'group-order-details-participants-requests-request';
    const currVal_1:any = ck(v,2,0,co.requestRemoved[(<any>v.parent).context.$implicit.transferRequestId]);
    ck(v,1,0,currVal_0,currVal_1);
    const currVal_3:any = (<any>v.parent).context.$implicit.subTotal;
    ck(v,8,0,currVal_3);
    const currVal_7:any = (co.requestRemoved[(<any>v.parent).context.$implicit.transferRequestId]? co.IconButtonType.INCREMENT: co.IconButtonType.REMOVE);
    ck(v,11,0,currVal_7);
  },(ck,v) => {
    const currVal_2:any = (<any>v.parent).context.$implicit.transferRequestName;
    ck(v,5,0,currVal_2);
    const currVal_4:any = import0.ɵnov(v,11).type;
    const currVal_5:any = import0.ɵnov(v,11).disabled;
    const currVal_6:any = import0.ɵnov(v,11).unavailable;
    ck(v,10,0,currVal_4,currVal_5,currVal_6);
  });
}
function View_GroupOrderPageComponent_11(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,(null as any),(null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_12)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    const currVal_0:any = v.context.$implicit.transferRequestId;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_GroupOrderPageComponent_10(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'group-order-details-participants-requests'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_11)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.orderModel.transferRequests;
    ck(v,3,0,currVal_0);
  },(null as any));
}
function View_GroupOrderPageComponent_8(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),11,'div',[[
        'class',
        'group-order-details-participants'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'group-order-details-participants-heading'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                ',
      '\n            '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_9)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_10)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:boolean = !co.orderModel.totalTransfers;
    ck(v,7,0,currVal_1);
    const currVal_2:any = co.orderModel.totalTransfers;
    ck(v,10,0,currVal_2);
  },(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = import0.ɵunv(v,3,0,import0.ɵnov(v,4).transform(co.editParticipantsHeading));
    ck(v,3,0,currVal_0);
  });
}
function View_GroupOrderPageComponent_6(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),24,'div',[[
        'class',
        'group-order-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'woa-form',([] as any[]),(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.saveGroupOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import12.View_FormComponent_0,import12.RenderType_FormComponent)),
      import0.ɵdid(1097728,[[
        2,
        4
      ]
    ],2,import13.FormComponent,[import3.NotificationService],(null as any),{onSubmit: 'onSubmit'}),
    import0.ɵqud(603979776,6,{models: 1}),
    import0.ɵqud(603979776,7,{modelContainers: 1}),
    import0.ɵprd(5120,(null as any),import13.FORM_CONTROL,(p0_0:any) => {
      return [p0_0];
    },[import13.FormComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[
      [
        'class',
        'group-order-details-name'
      ]
      ,
      [
        'name',
        'name'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.newGroupOrderName = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_TextFieldComponent_0,import14.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import15.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import15.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import15.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import15.RequiredValidator,
      import15.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import16.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]

    }
    ,(null as any)),
    import0.ɵprd(1024,(null as any),import15.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import16.TextFieldComponent]),
      import0.ɵdid(671744,[[
        6,
        4
      ]
    ],0,import15.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import15.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import15.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import15.NgControl,(null as any),[import15.NgModel]),
    import0.ɵdid(16384,(null as any),0,import15.NgControlStatus,[import15.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_7)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_8)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_9:any = '';
    ck(v,9,0,currVal_9);
    const currVal_10:any = '25';
    ck(v,10,0,currVal_10);
    const currVal_11:any = 'woa.label.group-order.groupOrderName';
    const currVal_12:any = 'given-name';
    const currVal_13:any = '25';
    ck(v,12,0,currVal_11,currVal_12,currVal_13);
    const currVal_14:any = 'name';
    const currVal_15:any = co.newGroupOrderName;
    ck(v,14,0,currVal_14,currVal_15);
    const currVal_16:any = co.showEditInstructions;
    ck(v,20,0,currVal_16);
    const currVal_17:any = co.showEditParticipants;
    ck(v,23,0,currVal_17);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,9).required? '': (null as any));
    const currVal_1:any = (import0.ɵnov(v,10).maxlength? import0.ɵnov(v,10).maxlength: (null as any));
    const currVal_2:any = import0.ɵnov(v,16).ngClassUntouched;
    const currVal_3:any = import0.ɵnov(v,16).ngClassTouched;
    const currVal_4:any = import0.ɵnov(v,16).ngClassPristine;
    const currVal_5:any = import0.ɵnov(v,16).ngClassDirty;
    const currVal_6:any = import0.ɵnov(v,16).ngClassValid;
    const currVal_7:any = import0.ɵnov(v,16).ngClassInvalid;
    const currVal_8:any = import0.ɵnov(v,16).ngClassPending;
    ck(v,8,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  });
}
function View_GroupOrderPageComponent_16(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'participation-details-targets-list-target'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.selectParticipantTarget(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-selector-control',[[
        'class',
        'participation-details-targets-list-target-selector'
      ]
    ],[
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'touched',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'selectedChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('selectedChange' === en)) {
        const pd_0:any = ((<any>co.selectParticipantTarget(v.context.$implicit)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import17.View_SelectorControlComponent_0,import17.RenderType_SelectorControlComponent)),
    import0.ɵdid(49152,(null as any),0,import18.SelectorControlComponent,([] as any[]),{
      type: [
        0,
        'type'
      ]
      ,
      selected: [
        1,
        'selected'
      ]

    }
    ,{selectedChange: 'selectedChange'}),
    (l()(),import0.ɵted((null as any),['\n                    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'participation-details-targets-list-target-name'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                        ',
      '\n                    '
    ]
    )),
    (l()(),import0.ɵted((null as any),['\n                ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_2:any = co.SelectorType.RADIO;
    const currVal_3:any = (v.context.$implicit === co.selectedTransferTarget);
    ck(v,3,0,currVal_2,currVal_3);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,3).disabled;
    const currVal_1:any = import0.ɵnov(v,3).touched;
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_4:any = v.context.$implicit.name;
    ck(v,6,0,currVal_4);
  });
}
function View_GroupOrderPageComponent_15(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),20,'div',[[
        'class',
        'participation-details-targets'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),9,'div',[
      [
        'class',
        'participation-details-targets-heading'
      ]
      ,
      [
        'woa-touchable',
        ''
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(4210688,(null as any),0,import7.TouchableDirective,[import0.ElementRef],(null as any),(null as any)),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),2,'div',[[
        'class',
        'participation-details-targets-heading-label'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.toggleParticipantTargets(import0.ɵnov(v,13))) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[
      '\n                    ',
      '\n                '
    ]
    )),
    import0.ɵpid(131072,import4.TranslatePipe,[
      import5.TranslateService,
      import0.ChangeDetectorRef
    ]
    ),
    (l()(),import0.ɵted((null as any),['\n                '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-toggle',[[
        'class',
        'participation-details-targets-heading-toggle'
      ]
    ],(null as any),(null as any),(null as any),import8.View_ToggleComponent_0,import8.RenderType_ToggleComponent)),
      import0.ɵdid(573440,(null as any),0,import9.ToggleComponent,[import0.ChangeDetectorRef],{active: [
        0,
        'active'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n            '])),
      (l()(),import0.ɵeld(0,[[
        'targetList',
        1
      ]
      ],(null as any),6,'div',[[
        'class',
        'participation-details-targets-list'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import6.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    import0.ɵpod(['expanded']),
    (l()(),import0.ɵted((null as any),['\n                '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_16)),
    import0.ɵdid(802816,(null as any),0,import6.NgForOf,[
      import0.ViewContainerRef,
      import0.TemplateRef,
      import0.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵted((null as any),['\n        ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_1:any = co.targetsExpanded;
    ck(v,10,0,currVal_1);
    const currVal_2:any = 'participation-details-targets-list';
    const currVal_3:any = ck(v,15,0,co.targetsExpanded);
    ck(v,14,0,currVal_2,currVal_3);
    const currVal_4:any = co.otherTransferTargets;
    ck(v,18,0,currVal_4);
  },(ck,v) => {
    const currVal_0:any = import0.ɵunv(v,6,0,import0.ɵnov(v,7).transform('woa.heading.group-order.targets'));
    ck(v,6,0,currVal_0);
  });
}
function View_GroupOrderPageComponent_14(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),21,'div',[[
        'class',
        'participation-details'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),15,'woa-form',([] as any[]),(null as any),[[
        (null as any),
        'onSubmit'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onSubmit' === en)) {
        const pd_0:any = ((<any>co.joinGroupOrder($event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import12.View_FormComponent_0,import12.RenderType_FormComponent)),
      import0.ɵdid(1097728,[[
        2,
        4
      ]
    ],2,import13.FormComponent,[import3.NotificationService],(null as any),{onSubmit: 'onSubmit'}),
    import0.ɵqud(603979776,8,{models: 1}),
    import0.ɵqud(603979776,9,{modelContainers: 1}),
    import0.ɵprd(5120,(null as any),import13.FORM_CONTROL,(p0_0:any) => {
      return [p0_0];
    },[import13.FormComponent]),
    (l()(),import0.ɵted(0,['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),0,8,'woa-text-field',[
      [
        'class',
        'participation-details-name'
      ]
      ,
      [
        'name',
        'name'
      ]
      ,
      [
        'required',
        ''
      ]

    ]
    ,[
      [
        1,
        'required',
        0
      ]
      ,
      [
        1,
        'maxlength',
        0
      ]
      ,
      [
        2,
        'ng-untouched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-touched',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pristine',
        (null as any)
      ]
      ,
      [
        2,
        'ng-dirty',
        (null as any)
      ]
      ,
      [
        2,
        'ng-valid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-invalid',
        (null as any)
      ]
      ,
      [
        2,
        'ng-pending',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'ngModelChange'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('ngModelChange' === en)) {
        const pd_0:any = ((<any>(co.orderFirstName = $event)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import14.View_TextFieldComponent_0,import14.RenderType_TextFieldComponent)),
      import0.ɵdid(16384,(null as any),0,import15.RequiredValidator,([] as any[]),{required: [
        0,
        'required'
      ]
    },(null as any)),
      import0.ɵdid(540672,(null as any),0,import15.MaxLengthValidator,([] as any[]),{maxlength: [
        0,
        'maxlength'
      ]
    },(null as any)),
    import0.ɵprd(1024,(null as any),import15.NG_VALIDATORS,(p0_0:any,p1_0:any) => {
      return [
        p0_0,
        p1_0
      ]
      ;
    },[
      import15.RequiredValidator,
      import15.MaxLengthValidator
    ]
    ),
    import0.ɵdid(180224,(null as any),0,import16.TextFieldComponent,[import0.ChangeDetectorRef],{
      label: [
        0,
        'label'
      ]
      ,
      autocomplete: [
        1,
        'autocomplete'
      ]
      ,
      maxlength: [
        2,
        'maxlength'
      ]

    }
    ,(null as any)),
    import0.ɵprd(1024,(null as any),import15.NG_VALUE_ACCESSOR,(p0_0:any) => {
      return [p0_0];
    },[import16.TextFieldComponent]),
      import0.ɵdid(671744,[[
        8,
        4
      ]
    ],0,import15.NgModel,[
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import15.NG_VALIDATORS
      ]
      ,
      [
        8,
        (null as any)
      ]
      ,
      [
        2,
        import15.NG_VALUE_ACCESSOR
      ]

    ]
    ,{
      name: [
        0,
        'name'
      ]
      ,
      model: [
        1,
        'model'
      ]

    }
    ,{update: 'ngModelChange'}),
    import0.ɵprd(2048,(null as any),import15.NgControl,(null as any),[import15.NgModel]),
    import0.ɵdid(16384,(null as any),0,import15.NgControlStatus,[import15.NgControl],(null as any),(null as any)),
    (l()(),import0.ɵted(0,['\n        '])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_GroupOrderPageComponent_15)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    ']))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_9:any = '';
    ck(v,9,0,currVal_9);
    const currVal_10:any = '25';
    ck(v,10,0,currVal_10);
    const currVal_11:any = 'woa.label.common.firstName';
    const currVal_12:any = 'given-name';
    const currVal_13:any = '25';
    ck(v,12,0,currVal_11,currVal_12,currVal_13);
    const currVal_14:any = 'name';
    const currVal_15:any = co.orderFirstName;
    ck(v,14,0,currVal_14,currVal_15);
    const currVal_16:any = (co.otherTransferTargets.length > 1);
    ck(v,20,0,currVal_16);
  },(ck,v) => {
    const currVal_0:any = (import0.ɵnov(v,9).required? '': (null as any));
    const currVal_1:any = (import0.ɵnov(v,10).maxlength? import0.ɵnov(v,10).maxlength: (null as any));
    const currVal_2:any = import0.ɵnov(v,16).ngClassUntouched;
    const currVal_3:any = import0.ɵnov(v,16).ngClassTouched;
    const currVal_4:any = import0.ɵnov(v,16).ngClassPristine;
    const currVal_5:any = import0.ɵnov(v,16).ngClassDirty;
    const currVal_6:any = import0.ɵnov(v,16).ngClassValid;
    const currVal_7:any = import0.ɵnov(v,16).ngClassInvalid;
    const currVal_8:any = import0.ɵnov(v,16).ngClassPending;
    ck(v,8,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,currVal_7,currVal_8);
  });
}
function View_GroupOrderPageComponent_17(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'cancel-group-order-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.closeGroupOrder()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_ButtonComponent_0,import19.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import20.ButtonComponent,[
      import0.ElementRef,
      import21.SessionModel,
      import0.ChangeDetectorRef,
      import22.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]
      ,
      connotation: [
        2,
        'connotation'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import23.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.cancelButtonLabel;
    const currVal_28:any = co.ButtonProminence.LOW;
    const currVal_29:any = co.ButtonConnotation.NEGATIVE;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_GroupOrderPageComponent_18(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'save-group-order-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_ButtonComponent_0,import19.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import20.ButtonComponent,[
      import0.ElementRef,
      import21.SessionModel,
      import0.ChangeDetectorRef,
      import22.ResponsiveService
    ]
      ,{label: [
        0,
        'label'
      ]
    },(null as any)),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import23.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.saveButtonLabel;
    ck(v,1,0,currVal_27);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_GroupOrderPageComponent_19(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-button',[
      [
        'id',
        'no-join-group-order-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.navigationService.dismissPage(co)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_ButtonComponent_0,import19.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import20.ButtonComponent,[
      import0.ElementRef,
      import21.SessionModel,
      import0.ChangeDetectorRef,
      import22.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      prominence: [
        1,
        'prominence'
      ]

    }
    ,(null as any)),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import23.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.group-order.noJoin';
    const currVal_28:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_GroupOrderPageComponent_20(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-button',[
      [
        'id',
        'keep-group-order-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit(co.existingTransferTarget)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_ButtonComponent_0,import19.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import20.ButtonComponent,[
      import0.ElementRef,
      import21.SessionModel,
      import0.ChangeDetectorRef,
      import22.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]
      ,
      prominence: [
        2,
        'prominence'
      ]

    }
    ,(null as any)),
    import0.ɵppd(1),
    import0.ɵpod(['groupOrderName']),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import23.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = 'woa.button.group-order.keep';
    const currVal_28:any = ck(v,3,0,import0.ɵunv(v,1,1,ck(v,2,0,import0.ɵnov((<any>v.parent),0),((co.existingTransferTarget == null)? (null as any): co.existingTransferTarget.name))));
    const currVal_29:any = co.ButtonProminence.LOW;
    ck(v,1,0,currVal_27,currVal_28,currVal_29);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_GroupOrderPageComponent_21(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'woa-button',[
      [
        'id',
        'join-group-order-button'
      ]
      ,
      [
        'woa-page-footer-control',
        ''
      ]

    ]
    ,[
      [
        2,
        'override-flat-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-flat-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-outline-border-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-background-color',
        (null as any)
      ]
      ,
      [
        2,
        'override-raised-foreground-color',
        (null as any)
      ]
      ,
      [
        2,
        'disabled',
        (null as any)
      ]
      ,
      [
        2,
        'invisible',
        (null as any)
      ]
      ,
      [
        2,
        'hovered',
        (null as any)
      ]
      ,
      [
        2,
        'native',
        (null as any)
      ]
      ,
      [
        2,
        'woa-button',
        (null as any)
      ]
      ,
      [
        2,
        'tier-first',
        (null as any)
      ]
      ,
      [
        2,
        'tier-second',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-high',
        (null as any)
      ]
      ,
      [
        2,
        'prominence-low',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-affirmative',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-dissuasive',
        (null as any)
      ]
      ,
      [
        2,
        'connotation-negative',
        (null as any)
      ]
      ,
      [
        2,
        'shape-square',
        (null as any)
      ]
      ,
      [
        2,
        'shape-rounded',
        (null as any)
      ]
      ,
      [
        2,
        'shape-oval',
        (null as any)
      ]
      ,
      [
        2,
        'style-flat',
        (null as any)
      ]
      ,
      [
        2,
        'style-outline',
        (null as any)
      ]
      ,
      [
        2,
        'style-raised',
        (null as any)
      ]
      ,
      [
        2,
        'layout-vertical',
        (null as any)
      ]
      ,
      [
        2,
        'layout-horizontal',
        (null as any)
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).buttonClicked($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('click' === en)) {
        const pd_1:any = ((<any>co.form.submit(co.selectedTransferTarget)) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },import19.View_ButtonComponent_0,import19.RenderType_ButtonComponent)),
    import0.ɵdid(245760,(null as any),0,import20.ButtonComponent,[
      import0.ElementRef,
      import21.SessionModel,
      import0.ChangeDetectorRef,
      import22.ResponsiveService
    ]
    ,{
      label: [
        0,
        'label'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵppd(1),
    import0.ɵpod(['groupOrderName']),
      import0.ɵdid(16384,[[
        4,
        4
      ]
    ],0,import23.PageFooterControlDirective,([] as any[]),(null as any),(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_27:any = co.joinButtonLabel;
    const currVal_28:any = ck(v,3,0,import0.ɵunv(v,1,1,ck(v,2,0,import0.ɵnov((<any>v.parent),0),((co.selectedTransferTarget == null)? (null as any): co.selectedTransferTarget.name))));
    ck(v,1,0,currVal_27,currVal_28);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,1).overrideFlatBackgroundColor;
    const currVal_1:any = import0.ɵnov(v,1).overrideFlatForegroundColor;
    const currVal_2:any = import0.ɵnov(v,1).overrideOutlineBackgroundColor;
    const currVal_3:any = import0.ɵnov(v,1).overrideOutlineForegroundColor;
    const currVal_4:any = import0.ɵnov(v,1).overrideOutlineBorderColor;
    const currVal_5:any = import0.ɵnov(v,1).overrideRaisedBackgroundColor;
    const currVal_6:any = import0.ɵnov(v,1).overrideRaisedForegroundColor;
    const currVal_7:any = import0.ɵnov(v,1).disabled;
    const currVal_8:any = import0.ɵnov(v,1).invisible;
    const currVal_9:any = import0.ɵnov(v,1).hovered;
    const currVal_10:any = import0.ɵnov(v,1).native;
    const currVal_11:any = import0.ɵnov(v,1).button;
    const currVal_12:any = import0.ɵnov(v,1).firstTier;
    const currVal_13:any = import0.ɵnov(v,1).secondTier;
    const currVal_14:any = import0.ɵnov(v,1).highProminence;
    const currVal_15:any = import0.ɵnov(v,1).lowProminence;
    const currVal_16:any = import0.ɵnov(v,1).affirmativeConnotation;
    const currVal_17:any = import0.ɵnov(v,1).dissuasiveConnotation;
    const currVal_18:any = import0.ɵnov(v,1).negativeConnotation;
    const currVal_19:any = import0.ɵnov(v,1).squareShape;
    const currVal_20:any = import0.ɵnov(v,1).roundedShape;
    const currVal_21:any = import0.ɵnov(v,1).ovalShape;
    const currVal_22:any = import0.ɵnov(v,1).flatStyle;
    const currVal_23:any = import0.ɵnov(v,1).outlineStyle;
    const currVal_24:any = import0.ɵnov(v,1).raisedStyle;
    const currVal_25:any = import0.ɵnov(v,1).verticalLayout;
    const currVal_26:any = import0.ɵnov(v,1).horizontalLayout;
    ck(v,0,1,[
      currVal_0,
      currVal_1,
      currVal_2,
      currVal_3,
      currVal_4,
      currVal_5,
      currVal_6,
      currVal_7,
      currVal_8,
      currVal_9,
      currVal_10,
      currVal_11,
      currVal_12,
      currVal_13,
      currVal_14,
      currVal_15,
      currVal_16,
      currVal_17,
      currVal_18,
      currVal_19,
      currVal_20,
      currVal_21,
      currVal_22,
      currVal_23,
      currVal_24,
      currVal_25,
      currVal_26
    ]
    );
  });
}
function View_GroupOrderPageComponent_22(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-link',[
      [
        'class',
        'participation-link'
      ]
      ,
      [
        'slot',
        'footer-end'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'onActivate'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('onActivate' === en)) {
        const pd_0:any = ((<any>co.startNewGroupOrder()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },import24.View_LinkComponent_0,import24.RenderType_LinkComponent)),
      import0.ɵdid(49152,(null as any),0,import25.LinkComponent,([] as any[]),{link: [
        0,
        'link'
      ]
    },{onActivate: 'onActivate'})
  ]
  ,(ck,v) => {
    const currVal_0:any = 'woa.button.group-order.createNew';
    ck(v,1,0,currVal_0);
  },(null as any));
}
export function View_GroupOrderPageComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵpid(0,import26.PossessivePipe,([] as any[])),
    import0.ɵpid(0,import27.HtmlPipe,[import28.DomSanitizer]),
    import0.ɵpid(0,import29.CurrencyPipe,([] as any[])),
    import0.ɵqud(402653184,1,{pageLayout: 0}),
    import0.ɵqud(671088640,2,{form: 0}),
    (l()(),import0.ɵeld(0,(null as any),(null as any),37,'woa-modal-page-layout',([] as any[]),(null as any),(null as any),(null as any),import30.View_ModalPageLayoutComponent_0,import30.RenderType_ModalPageLayoutComponent)),
    import0.ɵdid(114688,(null as any),2,import31.ModalPageLayoutComponent,[
      import32.Page,
      import33.NavigationService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      translationParams: [
        1,
        'translationParams'
      ]

    }
    ,(null as any)),
    import0.ɵqud(603979776,3,{contentMessages: 1}),
    import0.ɵqud(603979776,4,{footerControls: 1}),
    import0.ɵppd(1),
    import0.ɵpod(['groupOrderName']),
      import0.ɵprd(2048,[[
        1,
        4
      ]
    ],import32.PageLayout,(null as any),[import31.ModalPageLayoutComponent]),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),3,1,(null as any),View_GroupOrderPageComponent_1)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_GroupOrderPageComponent_2)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_GroupOrderPageComponent_6)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),4,1,(null as any),View_GroupOrderPageComponent_14)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_GroupOrderPageComponent_17)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_GroupOrderPageComponent_18)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_GroupOrderPageComponent_19)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_GroupOrderPageComponent_20)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),7,1,(null as any),View_GroupOrderPageComponent_21)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),8,1,(null as any),View_GroupOrderPageComponent_22)),
    import0.ɵdid(16384,(null as any),0,import6.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted(4,['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import34.GroupOrderPageComponent = v.component;
    const currVal_0:any = co.title;
    const currVal_1:any = ck(v,10,0,import0.ɵunv(v,6,1,ck(v,9,0,import0.ɵnov(v,0),co.currentGroupOrderName)));
    ck(v,6,0,currVal_0,currVal_1);
    const currVal_2:any = co.error;
    ck(v,14,0,currVal_2);
    const currVal_3:boolean = !co.error;
    ck(v,17,0,currVal_3);
    const currVal_4:any = ((co.mode === co.GroupOrderPageMode.EDIT) && co.groupOrderModel.canStartGroupOrder);
    ck(v,20,0,currVal_4);
    const currVal_5:any = (co.mode === co.GroupOrderPageMode.PARTICIPANTS);
    ck(v,23,0,currVal_5);
    const currVal_6:any = ((((co.mode === co.GroupOrderPageMode.EDIT) && (co.groupOrderStatus !== co.OrderTransferTargetStatus.CLOSED)) && co.groupOrderModel.canStartGroupOrder) || co.reorderStatus);
    ck(v,26,0,currVal_6);
    const currVal_7:any = (co.form && (co.mode === co.GroupOrderPageMode.EDIT));
    ck(v,29,0,currVal_7);
    const currVal_8:any = ((co.mode === co.GroupOrderPageMode.PARTICIPANTS) && !co.existingTransferTarget);
    ck(v,32,0,currVal_8);
    const currVal_9:any = (((co.form && (co.mode === co.GroupOrderPageMode.PARTICIPANTS)) && co.existingTransferTarget) && co.newestOtherTransferTarget);
    ck(v,35,0,currVal_9);
    const currVal_10:any = (co.form && (co.mode === co.GroupOrderPageMode.PARTICIPANTS));
    ck(v,38,0,currVal_10);
    const currVal_11:any = ((co.mode === co.GroupOrderPageMode.PARTICIPANTS) && !co.hideNewGroupOrder);
    ck(v,41,0,currVal_11);
  },(null as any));
}
function View_GroupOrderPageComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'woa-group-order-page',([] as any[]),(null as any),(null as any),(null as any),View_GroupOrderPageComponent_0,RenderType_GroupOrderPageComponent)),
    import0.ɵdid(4374528,(null as any),0,import34.GroupOrderPageComponent,[
      import35.NavigationParams,
      import36.LoadingService,
      import37.IdentityModel,
      import0.ChangeDetectorRef,
      import3.NotificationService,
      import33.NavigationService,
      import38.OrderModel,
      import39.GroupOrderModel
    ]
    ,(null as any),(null as any)),
    import0.ɵprd(6144,(null as any),import32.Page,(null as any),[import34.GroupOrderPageComponent])
  ]
  ,(null as any),(null as any));
}
export const GroupOrderPageComponentNgFactory:import0.ComponentFactory<import34.GroupOrderPageComponent> = import0.ɵccf('woa-group-order-page',import34.GroupOrderPageComponent,View_GroupOrderPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/group-order/group-order-page/group-order-page.component.ngfactory.ts